<template>
  <div class="theme-card-wrapper" :class="wrapperClass">
    <div class="theme-card-title">
      <slot name="title"></slot>
    </div>

    <div class="theme-card-content">
      <slot name="content"></slot>
    </div>
  </div>
</template>

<script>
export default {
  props: ["theme"],
  data() {
    return {
      wrapperClass: "theme-default"
    };
  },
  methods: {
  },
  created() {
    this.wrapperClass = this.theme && this.theme === "primary" ? "theme-primary" : "theme-default";
  }
};
</script>

<style lang="scss" scoped>
.theme-card-wrapper {
  border-radius: 8px;
  overflow: hidden;

  &.theme-primary {
    > .theme-card-title {
      background-color: var(--theme-red);
    }

    > .theme-card-content {
      background-color: rgba(203, 36, 43, 0.04);
    }
  }

  &.theme-default {
    > .theme-card-title {
      background-color: var(--theme-deafult);
    }

    > .theme-card-content {
      background-color: rgba(113, 40, 232, 0.04);
    }
  }

  > .theme-card-title {
    color: #fff;
    padding: 0.25rem 0.5rem;
  }

  > .theme-card-content {
    padding: 1rem;
    height: 100%;
  }
}
</style>